import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ArchiveProjectRPC } from "./archiveProjectRPC";

export class ArchiveProjectRPCClientImpl extends ArchiveProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ArchiveProjectRPC.Request): Promise<LeoRPCResult<ArchiveProjectRPC.Response, ArchiveProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/ArchiveProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ArchiveProjectRPC.ResponseDTO,
      ArchiveProjectRPC.Errors.ErrorsDTO,
      ArchiveProjectRPC.Response,
      ArchiveProjectRPC.Errors.Errors
    >(
      response,
      "project/ArchiveProject",
      ArchiveProjectRPC.Response.fromDTO,
      ArchiveProjectRPC.Errors.fromDTO
    );
  }
}
